/** The lucide icons a project can pick (project switcher, settings) — also the set the contact-card avatars are pre-rendered for (scripts/contact-avatars). */
export const PROJECT_ICONS = [
  'folder',
  'briefcase',
  'rocket',
  'globe',
  'star',
  'zap',
  'heart',
  'code',
  'book',
  'music',
  'camera',
  'cpu',
  'database',
  'shield',
  'target',
  'truck',
  'home',
  'sun',
  'cloud',
  'award',
  'palette',
  'flask-conical',
  'graduation-cap',
  'shopping-cart',
  'wrench',
  'gamepad-2',
  'plane',
  'landmark',
  'megaphone',
  'leaf',
] as const

export type ProjectIconKey = (typeof PROJECT_ICONS)[number]
